import { Select as GammaSelect } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type SelectProps = React.ComponentProps<typeof GammaSelect>

type Props = Omit<SelectProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const Select = ({ missingLabel, ...props }: Props) => (
  <GammaSelect
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

export default Select
